export default __webpack_public_path__ + "static/measuring-0b11c57d0355a14cb13f5f20ae8b9318.png";